import { RechargeType, SubscriptionType } from "types/enums";

export const subscriptionCost = {
  FREE: 0,
  PREMIUM: 150,
  PRO: 450,
};

export const subscriptionDcaBots = {
  FREE: 2,
  PREMIUM: 10,
  PRO: 50,
};

export const subscriptionLimitOrders = {
  FREE: 1,
  PREMIUM: 5,
  PRO: 15,
};

export const subscriptionSingleLimitOrders = {
  FREE: "-",
  PREMIUM: 15,
  PRO: 50,
};

export const subscriptionMinGridPercentStep = {
  FREE: 2.5,
  PREMIUM: 1,
  PRO: 1,
};

export const subscriptionDefaultGridPercentStep = {
  FREE: 2.5,
  PREMIUM: 1.5,
  PRO: 1.5,
};

export const subscriptionBots = {
  FREE: 1,
  PREMIUM: 4,
  PRO: 10,
};

export const rechargeOptions = [
  {
    type: RechargeType.RECHARGE_150,
    prevType: RechargeType.RECHARGE_125,
    defaultPrice: 150,
    unlocks: SubscriptionType.PREMIUM,
    discountFrom: undefined,
  },
  {
    type: RechargeType.RECHARGE_450,
    prevType: RechargeType.RECHARGE_400,
    defaultPrice: 450,
    unlocks: SubscriptionType.PRO,
    discountFrom: undefined,
  },
];